import { SvgIcon } from '@mui/material';

const Bill = () => (
  <SvgIcon
    viewBox="0 0 24 25"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 24, height: 25, fill: 'none' }}
    data-testid="billIcon"
  >
    <g clipPath="url(#clip0_6406_16781)">
      <path
        d="M9.15836 9.26969C9.19267 9.51025 9.26007 9.69008 9.36055 9.80917C9.54435 10.0259 9.85928 10.1343 10.3053 10.1343C10.5724 10.1343 10.7893 10.1057 10.956 10.0485C11.2721 9.93898 11.4302 9.73533 11.4302 9.43761C11.4302 9.26373 11.3518 9.12916 11.1949 9.03389C11.0381 8.941 10.7918 8.85883 10.456 8.78737L9.88256 8.66233C9.31888 8.53848 8.92921 8.4039 8.71355 8.25861C8.34838 8.01567 8.1658 7.63577 8.1658 7.11892C8.1658 6.64732 8.34226 6.25552 8.69517 5.9435C9.04807 5.63149 9.56641 5.47548 10.2502 5.47548C10.8212 5.47548 11.3077 5.62315 11.7096 5.91849C12.114 6.21145 12.326 6.6378 12.3456 7.19752H11.2574C11.2378 6.88074 11.0957 6.65566 10.831 6.52228C10.6545 6.43415 10.4352 6.39009 10.173 6.39009C9.88133 6.39009 9.64851 6.44725 9.47451 6.56158C9.3005 6.67591 9.2135 6.83549 9.2135 7.04032C9.2135 7.22848 9.29928 7.36901 9.47083 7.4619C9.58111 7.52383 9.81639 7.59647 10.1766 7.67984L11.1104 7.89777C11.5197 7.99304 11.8285 8.12047 12.0368 8.28005C12.3603 8.52776 12.522 8.88622 12.522 9.35543C12.522 9.83656 12.3321 10.2367 11.9522 10.5559C11.5748 10.8726 11.0405 11.031 10.3494 11.031C9.64361 11.031 9.08851 10.875 8.68414 10.563C8.27976 10.2486 8.07758 9.8175 8.07758 9.26969H9.15836Z"
        fill="#0B1421"
      />
      <path
        d="M9.74424 4.91992H10.8554V6.03103H9.74424V4.91992Z"
        fill="#0B1421"
      />
      <path
        d="M9.74424 10.4755H10.8554V11.5866H9.74424V10.4755Z"
        fill="#0B1421"
      />
    </g>
    <path
      d="M5.83336 14.2082C5.83336 13.7763 6.18158 13.4261 6.61114 13.4261H13.9445C14.3741 13.4261 14.7223 13.7763 14.7223 14.2082C14.7223 14.6402 14.3741 14.9903 13.9445 14.9903H6.61114C6.18158 14.9903 5.83336 14.6402 5.83336 14.2082Z"
      fill="#0B1421"
    />
    <path
      d="M6.61114 16.778C6.18158 16.778 5.83336 17.1282 5.83336 17.5602C5.83336 17.9921 6.18158 18.3423 6.61114 18.3423H13.9445C14.3741 18.3423 14.7223 17.9921 14.7223 17.5602C14.7223 17.1282 14.3741 16.778 13.9445 16.778H6.61114Z"
      fill="#0B1421"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0563 7.83952H20.3889C21.0025 7.83952 21.5 7.33928 21.5 6.72221V5.60489C21.5 3.7537 20.0075 2.25301 18.1666 2.25293H5.83336C3.9924 2.25293 2.5 3.75365 2.5 5.60489V18.901C2.5 20.7522 3.9924 22.2529 5.83336 22.2529H14.7223C16.5633 22.2529 18.0557 20.7522 18.0557 18.901L18.0563 18.8338V7.83952ZM16.9728 3.81718H5.83336C4.85151 3.81718 4.05557 4.61756 4.05557 5.60489V18.901C4.05557 19.8883 4.85151 20.6887 5.83336 20.6887H14.7223C15.7042 20.6887 16.5001 19.8883 16.5001 18.901V7.1412L16.5008 7.13981V5.5377C16.5008 4.90869 16.6731 4.32014 16.9728 3.81718ZM19.1996 4.15293C18.5921 4.15293 18.0996 4.64542 18.0996 5.25293V6.75293H20.2996V5.25293C20.2996 4.64542 19.8071 4.15293 19.1996 4.15293Z"
      fill="#0B1421"
    />
    <defs>
      <clipPath id="clip0_6406_16781">
        <rect
          width="8"
          height="8"
          fill="white"
          transform="translate(6.2998 4.25293)"
        />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default Bill;
